/**
 * Maintained by Sandon.
 */
<template>
<!--  {{loading ? loadingText : noDataText}}-->
  <div class="sy-filter-list">
    <p 
      v-if="loading || !filterItems.length" 
      class="sy-filter-list__empty"
      :style="{'min-width': `${width}px`}">
      <template v-if="loading">{{loadingText}}</template>
      <template v-else-if="useEmptySlot">
        <slot name="empty"></slot>
      </template>
      <template v-else>{{noDataText}}</template>
    </p>
    <ul
      v-else="filterItems.length"
      class="sy-filter-list__items"
      @click.stop>
      <li
        class="sy-filter-list__item"
        v-for="item in filterItems"
        :key="item.key"
        :class="{
          selected: selectedKeySet ? selectedKeySet.has(item.key) : isSelected(item.key), 
          disabled: disabledKeySet.has(item.key)
        }"
        :style="{'min-width': `${width}px`}"
        :title="item.label"
        @click="_clickFilterItem(item)">
        <div class="sy-filter-list__item-label">
          <div class="sy-filter-list__item-label-wrap" ref="labelWrap">
            <span
              v-for="part in _getShowedFilterItemParts(item.label)"
              :class="{red: part.isFilter}">
              {{part.isFilter ? filterKw : part.value}}
            </span>
          </div>
        </div>
<!--        <i class="el-icon-check"></i>-->
      </li>
      <li v-if="useSuffixSlot">
        <slot name="suffix"></slot>
      </li>
    </ul>

  </div>

</template>

<script>
  import i18n from './i18n'
  const pageText = window.fe.getPageText(i18n)

  export default {
    name: 'sy-filter-list',
    props: {
      filterMethod: {type: Function, default: null},
      filterKw: {type: String, default: ''},
      remoteFilter: {type: Function, default: null},
      items: {
        type: Array,
        default: () => [
          // {
          //   key: '',
          //   label: '',
          //   disabled: ''
          // }
        ]
      },
      // 判断是否选中的函数 todo deprecated, change TreeSelector and CascadeSelector first
      isSelected: {type: Function, default: null},
      // 选中的 key 的Set集合
      selectedKeySet: {type: Set, default: null},
      // containerWidth: {type: Number, default: 360},
      // 是否加载中
      loading: {type: Boolean, default: false},
      // 在没有remote-filter和filter-method的情况下，是否使用内置的filter逻辑（简单字符匹配）
      useDefaultFilter: {type: Boolean, default: true},
      // 多选时选中条目数限制,为 0 则不限制
      multipleLimit: {type: Number, default: 0},
      // 宽度
      width: {type: Number, default: 0},
      // 是否高亮搜索匹配部分
      highlight: {type: Boolean, default: true},
      // 加载中时的提示文案
      loadingText: {type: String, default: pageText.loadingText},
      // 无数据时的提示文案
      noDataText: {type: String, default: pageText.noDataText},
      // 是否使用 suffix slot
      useSuffixSlot: {type: Boolean, default: false},
      // 是否使用 empty slot
      useEmptySlot: {type: Boolean, default: false}
    },
    data () {
      return {
        filterItems: [
          // {
          //   key: '',
          //   label: '',
          //   disabled: ''
          // }
        ]
        // contentWidth: this.containerWidth // todo
      }
    },
    computed: {
      disabledKeySet: function () {
        return new Set(
          this.filterItems
            .filter(item => {
              return item.disabled
                || (this.multipleLimit && this.selectedKeySet.size >= this.multipleLimit && !this.selectedKeySet.has(item.key))
            })
            .map(_ => _.key)
        )
      }
    },
    watch: {
      filterKw: async function (val) {
        this._initFilterItems()
      },
      items: function () {
        this._initFilterItems()
      },
      filterItems: function () {
        // this._calcWidth(true)
      }
    },
    created () {
      this._initFilterItems()
    },
    mounted () {
      // this._calcWidth()
    },
    methods: {
      async _initFilterItems () {
        if (this.remoteFilter) {
          this.filterItems = (await this.remoteFilter(this.filterKw)) || []
        } else if (this.filterMethod) {
          this.filterItems =  this.filterMethod(this.filterKw)
        } else if (this.useDefaultFilter) {
          this.filterItems = this._defaultFilter(this.filterKw)
        } else {
          this.filterItems = this.items
        }
        this.$emit('change', this.filterItems)
      },
      // 过滤获得filterItems
      _defaultFilter (filter) {
        // 根据`filterCandidate`和`filter`，生成`filterItems`
        return this.items
          .filter((node) => {
            return node.label.toString().indexOf(filter) !== -1
          })
      },
      // 条目被选中
      _clickFilterItem (item) {
        if (this.disabledKeySet.has(item.key)) return
        this.$emit('item-click', item)
      },
      // 筛选项高亮展示
      _getShowedFilterItemParts (label) {
        if (!this.highlight || !this.filterKw) {
          return [{isFilter: false, value: label}]
        }

        let parts = label.toString().trim().split(this.filterKw)
        const targetParts = []
        parts.forEach((part, index) => {
          targetParts.push({isFilter: false, value: part})
          index !== parts.length - 1 && targetParts.push({isFilter: true, value: ''})
        })
        return targetParts
      },
      // 计算内容宽度
      // async _calcWidth (needNextTick = false) {
      //   if (needNextTick) {
      //     await this.$nextTick()
      //   }
      //   if (!this.$refs['labelWrap']) return
      //   this.contentWidth = this.$refs['labelWrap'].reduce((width, labelWrap) => {
      //     // 70 是左右padding值之和
      //     return Math.max(width, labelWrap.getBoundingClientRect().width + 70)
      //   }, this.containerWidth)
      // }
    }
  }
</script>

<style scoped lang="scss">
  .sy-filter-list{
    width: fit-content;
    white-space: nowrap;
    padding: 5px 0;
  }
  .sy-filter-list__items{
    box-sizing: border-box;
    width: fit-content;
    /*padding: 10px 0;*/
    /*overflow-y: scroll;*/
    /*box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);*/
    background: #fff;
    /*max-height: 350px;*/
  }
  .sy-filter-list__item{
    box-sizing: border-box;
    position: relative;
    height: 34px;
    padding: 0 20px;
    line-height: 34px;
    cursor: pointer;
    /* overflow: hidden; */

    .sy-filter-list__item-label{
      /* overflow: hidden; */
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .sy-filter-list__item-label-wrap{
      display: inline-block;
    }

    &:hover{
      background-color: #f5f7fa;
    }
    &.selected{
      color: #409eff;
      background-color: #f5f7fa;
      /* 
      padding-right: 50px;
      .el-icon-check{
        visibility: visible;
      }
      */
    }
    &.disabled{
      color: #c0c4cc;
      cursor: not-allowed;
    }
    span.red{
      color: red;
    }
    /*
    .el-icon-check{
      position: absolute;
      right: 20px;
      top: 0;
      visibility: hidden;
      padding-left: 20px;
      line-height: 34px;
    }
    */
  }
  .sy-filter-list__empty{
    padding: 10px 0;
    text-align: center;
  }
</style>
